import { ApplicationRef, inject, Injectable } from "@angular/core";
import { SwUpdate, VersionEvent } from "@angular/service-worker";
import { concat, first, interval } from "rxjs";
import { AppService } from "./app.service";

@Injectable({providedIn: 'root'})
export class AppUpdateService {
  private readonly UPDATE_CHECK_INTERVAL: number = 1 * 60 * 1000; // 1 minute

  private appRef = inject(ApplicationRef);
  private appService = inject(AppService);
  private updates = inject(SwUpdate);
  
  constructor() {
    const appIsStable$ = this.appRef.isStable.pipe(first((isStable) => isStable === true));
    const interval$ = interval(this.UPDATE_CHECK_INTERVAL); 
    const intervalOnceAppIsStable$ = concat(appIsStable$, interval$);
    
    intervalOnceAppIsStable$.subscribe(async () => {
      try {
        await this.updates.checkForUpdate();
      } catch {
        // Update check failed silently
      }
    });

    this.updates.versionUpdates.subscribe((event: VersionEvent) => {
      switch (event.type) {
        case 'VERSION_READY':
          this.appService.showUpdate({
            version: event.latestVersion.hash,
            action: 'reload'
          });
          break;
      }
    });
  }
}